import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from '@marty-js/design/src/utils/translation';
import { EmbedSlateContent } from '../article-processor/plugins/slate.content';

const Content = styled.div`
  background: var(--theme-background-contrast-background-color);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: var(--spacer) var(--spacer) var(--spacer);
  margin-bottom: var(--spacer);
`;

const Title = styled.div`
  color: var(--text-color);
  font-family: var(--theme-typography-primary-font);
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
`;

export type ResumeProps = {
  resumeJson?: string;
};

export const Resume = (params: ResumeProps) => {
  const { resumeJson } = params;
  const t = useTranslation();

  const contentConclusion = useMemo(() => {
    const resume = JSON.parse(resumeJson);

    return <EmbedSlateContent data={resume} />;
  }, [resumeJson]);

  if (resumeJson === null) {
    return null;
  }

  return (
    <Content>
      <Title>{t('sdk.resume.toResume')}</Title>
      {contentConclusion}
    </Content>
  );
};
